import { useMutation } from "@tanstack/react-query";
import api from "apis";
import { UpdateNoticeRequest } from "apis/data-contracts";

const useNoticeUpdateMutation = () => {
  return useMutation({
    mutationFn: ({
      title,
      content,
      noticeAttachmentFileList,
      isMobile,
      uuid,
    }: UpdateNoticeRequest & { uuid: string }) =>
      api.notice.updateNotice(uuid, {
        title,
        content,
        noticeAttachmentFileList,
        isMobile,
      }),
  });
};

export default useNoticeUpdateMutation;
